import request from '@/utils/request'
const Api = {
    NoticeHeader: '/Frontend/Notice/header',
    NoticeList: '/Frontend/Notice/list',
    NoticeView: '/Frontend/Notice/view'
}

/**
 * 封头配置
 * @returns 
 */
export function getNoticeHeader() {
    return request({
        url: Api.NoticeHeader,
        method: 'get',
    })
}
/**
 * 列表
 * @returns 
 */
export function getNoticeList() {
    return request({
        url: Api.NoticeList,
        method: 'get',
    })
}
/**
 * 查看
 * @returns 
 */
export function getNoticeView(parameter) {
    return request({
        url: Api.NoticeView,
        method: 'get',
        params: parameter
    })
}



// WEBPACK FOOTER //
// ./src/api/announcementcenter.js